import { EldMalfunctionsList } from "./EldMalfunctionsList";
import SyncProblemOutlinedIcon from "@material-ui/icons/SyncProblemOutlined";

export default {
  icon: SyncProblemOutlinedIcon,
  list: EldMalfunctionsList,
};
